<div [ngClass]="['toast__container', 'toast__container-' + options.payload.type]">
    <div class="toast__content">
        <div [ngClass]="['toast__icon', 'toast__icon-' + options.payload.type]"></div>
        <div class="toast__text">
            <div class="toast__title">{{ title }}</div>
            <div>{{ message }}</div>
        </div>
    </div>
    <div class="toast__close">
        <div class="toast__close-icon" (click)="remove()"></div>
    </div>
</div>